import React from "react";

function P2PLendingHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Build a Robust, Transparent P2P Lending Platform
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Launch a secure, efficient platform for peer-to-peer lending
                    with cutting-edge blockchain solutions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default P2PLendingHero;
